export * from './generic-card-view.component';
